"use strict";
// Copyright (C) 2017-2024 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var classnames_1 = __importDefault(require("classnames"));
var stremio_router_1 = require("stremio-router");
var components_1 = require("stremio/components");
var Cell_less_1 = __importDefault(require("./Cell.less"));
var Cell = function (_a) {
    var _b;
    var selected = _a.selected, monthInfo = _a.monthInfo, date = _a.date, items = _a.items, onClick = _a.onClick;
    var navigateWithOrigin = (0, stremio_router_1.useNavigateWithOrigin)().navigateWithOrigin;
    var _c = (0, react_1.useMemo)(function () { return [
        date.day === (selected === null || selected === void 0 ? void 0 : selected.day),
        date.day === monthInfo.today,
    ]; }, [selected, monthInfo, date]), active = _c[0], today = _c[1];
    var onCellClick = function () {
        onClick && onClick(date);
    };
    var onPosterClick = (0, react_1.useCallback)(function (event, target) {
        event.preventDefault();
        event.stopPropagation();
        navigateWithOrigin(target);
    }, [navigateWithOrigin]);
    return (react_1.default.createElement(components_1.Button, { className: (0, classnames_1.default)(Cell_less_1.default['cell'], (_b = {}, _b[Cell_less_1.default['active']] = active, _b[Cell_less_1.default['today']] = today, _b)), onClick: onCellClick },
        react_1.default.createElement("div", { className: Cell_less_1.default['heading'] },
            react_1.default.createElement("div", { className: Cell_less_1.default['day'] }, date.day)),
        react_1.default.createElement(components_1.HorizontalScroll, { className: Cell_less_1.default['items'] }, items.map(function (_a) {
            var id = _a.id, name = _a.name, poster = _a.poster, deepLinks = _a.deepLinks;
            return (react_1.default.createElement(components_1.Button, { key: id, className: Cell_less_1.default['item'], href: deepLinks.metaDetailsStreams, tabIndex: -1, onClick: function (event) { return onPosterClick(event, deepLinks.metaDetailsStreams); } },
                react_1.default.createElement(react_2.default, { className: Cell_less_1.default['icon'], name: 'play' }),
                react_1.default.createElement(components_1.Image, { className: Cell_less_1.default['poster'], src: poster, alt: name })));
        })),
        items.length > 0 ?
            react_1.default.createElement(react_2.default, { className: Cell_less_1.default['more'], name: 'more-horizontal' })
            :
                null));
};
exports.default = Cell;
